//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { IDataTypePanelRule, IMRDataTypePanelFormItemOptions, IMRDataTypePanelAdditionalOptions } from '../interfaces'

import { OpDataType } from "../../../../models/core"
import { LocalizationHelper } from "../../../../helpers"


export class DefaultRule implements IDataTypePanelRule {

    //#region IDataTypePanelRule Implementation

    public canHandle(opDataType: OpDataType): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise()
    }

    public getItemFormFieldOptions(opDataType: OpDataType, additionalOptions?: IMRDataTypePanelAdditionalOptions, isRequired?: boolean, data?: any): JQueryPromise<IMRDataTypePanelFormItemOptions> {
        if (opDataType != null) {
            const item: IMRDataTypePanelFormItemOptions = {
                dataField: opDataType.idDataType.toString(),
                editorType: 'dxTextBox',
                validationRules: this.getDataTypeRuleOptions(opDataType, isRequired),

                editorOptions: {
                    value: data
                },

                label: {
                    location: 'top',
                    text: opDataType.toString()
                },
            }

            return $.Deferred().resolve(item).promise()
        }

        return $.Deferred().resolve(null).promise()
    }

    //#endregion


    //#region Private Methods

    private getDataTypeRuleOptions(opDataType: OpDataType, isRequired: boolean = false): any[] {
        const validationRules: any[] = []

        if (isRequired) {
            validationRules.push({
                type: 'required',
                message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
            })
        }

        return validationRules
    }

    //#endregion

}